import deepEqual from 'fast-deep-equal'

import { doAppGraphqlRequest } from 'ducks/requests'
import { selectCustomFieldForKey } from 'ducks/crm/customFields'
import { all } from 'util/arrays'

import {
  customFieldValueCompanyNormalizationScheme,
  customFieldValueContactNormalizationScheme,
} from '../schema'
import { selectCustomFieldValueForCustomFieldKeyAndSubjectId } from '../selectors'
import { UPDATE_CUSTOM_FIELD_VALUE } from '../types'
import { customFieldValueNodeQuery } from './fetching'

const updateCustomFieldValueQuery = `
mutation UpdateCustomFieldValue(
  $input: CustomFieldValuesUpdateInput!,
  $customFieldIds: [ID!]
) {
  customFieldValuesUpdate(input: $input) {
    subject {
      ... on Node {
        id
      }
      ... on CustomFieldValuesField {
        customFieldValues(customFieldIds: $customFieldIds) {
          ${customFieldValueNodeQuery}
        }
      }
    }
  }
}
`
export function doUpdateCustomFieldValues(subjectId, fields) {
  return async dispatch => {
    const variables = {
      input: {
        subjectId,
        customFieldList: fields.map(({ id, value }) => ({
          customFieldIdOrKey: id,
          value: deepEqual(Object.keys(value), ['content'])
            ? value.content
            : value,
        })),
      },
      customFieldIds: fields.map(({ id }) => id),
    }
    const isSubjectCompany = subjectId.match(/^cm_/)
    return dispatch(
      doAppGraphqlRequest(
        UPDATE_CUSTOM_FIELD_VALUE,
        updateCustomFieldValueQuery,
        variables,
        {
          optimist: {
            entities: {
              [isSubjectCompany ? 'companies' : 'contacts']: {
                [subjectId]: {
                  id: subjectId,
                  customFieldValues: {
                    nodes: fields.map(({ key, value, valueId }) => ({
                      id: valueId,
                      key,
                      value,
                    })),
                  },
                },
              },
            },
          },
          meta: { mergeEntities: true },
          normalizationSchema: isSubjectCompany
            ? customFieldValueCompanyNormalizationScheme
            : customFieldValueContactNormalizationScheme,
        }
      )
    )
  }
}

function valueIsEmpty(value) {
  return (
    !value || all(x => ['', undefined, null].includes(x), Object.values(value))
  )
}

export function doUpdateCustomFieldValuesFromForm(subjectId, formData) {
  return (dispatch, getState) => {
    const state = getState()
    const newValues = Object.keys(formData)
      .map(key => {
        const { id: valueId, value: existingValue } =
          selectCustomFieldValueForCustomFieldKeyAndSubjectId(state, {
            customFieldKey: key,
            subjectId,
          }) || {}
        const { id } = selectCustomFieldForKey(state, { key })
        const newValue = formData[key]

        // If new and existing values are equivalent return early
        if (valueIsEmpty(newValue) && valueIsEmpty(existingValue)) return null
        if (deepEqual(newValue, existingValue)) return null

        return {
          key,
          id,
          valueId,
          value: newValue,
        }
      })
      .filter(x => x !== null)
    if (newValues.length > 0) {
      dispatch(doUpdateCustomFieldValues(subjectId, newValues))
    }
  }
}
